import React from 'react';
import { IndivalifeLogo } from '@/components/IndivalifeLogo';
import { InstallTopBar } from '@/components/InstallTopBar';
import { DualLoginCard } from '@/components/DualLoginCard';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Link } from 'react-router-dom';

const HERO_IMG = 'https://images.unsplash.com/photo-1758524944006-ba8116008496?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxtb2JpbGUlMjBzaG9wcGluZyUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3ODQ5ODQ0MTd8MA&ixlib=rb-4.1.0&q=85';

const Login = () => {
  const { user, loading } = useAuth();

  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (user) return <Navigate to="/store" replace />;

  const scrollToAccess = () => document.getElementById('access')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="min-h-screen bg-slate-50">
      <InstallTopBar />

      {/* Sticky glass header */}
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200/70">
        <div className="max-w-screen-xl mx-auto px-5 py-3 flex items-center justify-between">
          <IndivalifeLogo size={38} withWordmark />
          <div className="flex items-center gap-3">
            <button onClick={scrollToAccess} className="hidden sm:inline-flex text-xs font-bold text-[#1E3A8A] hover:text-[#1D4ED8] uppercase tracking-wider" data-testid="header-signin">Sign in</button>
            <Link to="/admin/login" className="text-[10px] sm:text-xs text-[var(--bz-muted)] hover:text-black font-semibold uppercase tracking-wider" data-testid="admin-link">Admin ›</Link>
          </div>
        </div>
      </header>

      {/* HERO with dual login */}
      <section id="access" className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A]/95 via-[#1D4ED8]/90 to-[#1E3A8A]/80" />
          <div className="absolute -top-16 -right-10 h-56 w-56 rounded-full bg-[var(--bz-orange)]/30 blur-3xl" />
          <div className="absolute bottom-0 -left-10 h-56 w-56 rounded-full bg-[var(--bz-gold)]/20 blur-3xl" />
        </div>

        <div className="relative max-w-screen-xl mx-auto px-5 pt-10 pb-14 grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
          <div className="text-white">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05] display">
              Welcome to<br /><span className="text-[var(--bz-gold)]">INDIVALIFE</span>
            </h1>
            <p className="mt-4 text-base text-white/85 max-w-md leading-relaxed">
              Sign in to access your account with your Personal ID &amp; password.
            </p>
          </div>

          {/* Dual login card */}
          <div className="w-full max-w-sm mx-auto lg:ml-auto">
            <DualLoginCard />
          </div>
        </div>
      </section>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-screen-xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <IndivalifeLogo size={32} withWordmark />
          <p className="text-xs text-[var(--bz-muted)]">© {new Date().getFullYear()} INDIVALIFE Pvt Ltd</p>
          <button onClick={scrollToAccess} className="text-xs font-bold text-[#1D4ED8]" data-testid="footer-signin">Sign in →</button>
        </div>
      </footer>
    </div>
  );
};

export default Login;
